const loginForm = () => {
  const signInForm = document.querySelector("form#customer_login")
  const signInButton = signInForm.querySelector("button#SignInButton")
  const email = signInForm.querySelector("input#CustomerEmail")
  const password = signInForm.querySelector("input#CustomerPassword")
  const passwordReqs = signInForm.querySelector(".password-requirements")
  const forgotLink = signInForm.querySelector("a[href='#recover']")
  const registerLink = signInForm.querySelector("a.create-account-link")
  const thisModal = signInForm.closest("modal-dialog")
  const dynamicHeroRedirectStorageKey = "dynamicHeroBannerRedirectUrl"
  const announcementBarRedirectStorageKey = "announcementBarLoginRedirect"

  const tbAuthExpectedClientId = () => {
    const cfg = window.__TB_AUTH_CONFIG__ || {}
    return String(cfg.clientId || "").trim()
  }

  const tbAuthParseIdToken = (idToken) => {
    try {
      let part = String(idToken || "").split(".")[1]
      if (!part) return null
      part = part.replace(/-/g, "+").replace(/_/g, "/")
      while (part.length % 4) part += "="
      return JSON.parse(atob(part))
    } catch (e) {
      return null
    }
  }

  const tbAuthTokenClientId = (idToken) => {
    const payload = tbAuthParseIdToken(idToken)
    if (!payload) return ""
    let aud = payload.aud
    if (Array.isArray(aud)) aud = aud[0]
    return aud || ""
  }

  const tbAuthTokenEmail = (idToken) => {
    const payload = tbAuthParseIdToken(idToken)
    if (!payload) return ""
    return String(
      payload.email || payload["cognito:username"] || payload.username || "",
    ).trim()
  }

  // Keep stored Cognito tokens only when they match this sign-in (client + user).
  const tbAuthTokensMatchSignIn = (idToken, email, expectedClient) => {
    if (!idToken) return false
    const storedClient = tbAuthTokenClientId(idToken)
    if (expectedClient && storedClient && storedClient !== expectedClient) {
      return false
    }
    const storedEmail = tbAuthTokenEmail(idToken)
    if (!storedEmail) return false
    return (
      storedEmail.toLowerCase() ===
      String(email || "")
        .trim()
        .toLowerCase()
    )
  }

  // Keep draft/preview theme query params after Multipass (Shopify drops them).
  const withPreviewParams = (targetUrl) => {
    try {
      const current = new URLSearchParams(window.location.search)
      const previewKeys = [
        "preview_theme_id",
        "key",
        "_ab",
        "_fd",
        "_sc",
        "preview",
      ]
      const next = new URL(targetUrl, window.location.origin)
      previewKeys.forEach((k) => {
        const v = current.get(k)
        if (v && !next.searchParams.has(k)) next.searchParams.set(k, v)
      })
      return next.pathname + next.search + next.hash
    } catch (e) {
      return targetUrl
    }
  }

  const getDynamicHeroRedirectUrl = () => {
    try {
      return window.localStorage.getItem(dynamicHeroRedirectStorageKey) || ""
    } catch (e) {
      return ""
    }
  }

  const clearDynamicHeroRedirectUrl = () => {
    try {
      window.localStorage.removeItem(dynamicHeroRedirectStorageKey)
    } catch (e) {}
  }

  const getAnnouncementBarRedirectData = () => {
    try {
      const raw = window.localStorage.getItem(announcementBarRedirectStorageKey)
      if (!raw) return null
      const data = JSON.parse(raw)
      return data && typeof data === "object" ? data : null
    } catch (e) {
      return null
    }
  }

  const clearAnnouncementBarRedirectData = () => {
    try {
      window.localStorage.removeItem(announcementBarRedirectStorageKey)
    } catch (e) {}
  }

  const getAnnouncementBarRedirectUrl = (redirectData) => {
    if (!redirectData) return ""

    const ctaUrl = String(redirectData.ctaUrl || "")
    const pdpUrl = String(redirectData.pdpUrl || "")
    const activeSaleEndsAt = Number(redirectData.activeSaleEndsAt) || 0
    const saleStillActive =
      activeSaleEndsAt > 0 && Math.floor(Date.now() / 1000) <= activeSaleEndsAt

    if (redirectData.originatedFromPdp && pdpUrl && saleStillActive) {
      return pdpUrl
    }

    return ctaUrl
  }

  const completeMultipassLogin = async (
    multipassPath,
    nextUrl,
    options = {},
  ) => {
    await fetch(multipassPath, {
      method: "GET",
      credentials: "include",
    })
    if (options.clearDynamicHeroRedirectUrl) {
      clearDynamicHeroRedirectUrl()
    }
    if (options.clearAnnouncementBarRedirectData) {
      clearAnnouncementBarRedirectData()
    }
    window.location.href = withPreviewParams(nextUrl || "/account")
  }

  const init = () => {
    registerLink.addEventListener("click", (event) => {
      event.preventDefault()
      const link = event.target
      const registerModal = document.querySelector(".register-modal")
      // if within a modal
      if (thisModal && registerModal) {
        // update modal contents
        thisModal.hide()
        registerModal.show()
      } else {
        // otherwise follow link
        window.location.href = link.getAttribute("href")
      }
    })

    signInButton.addEventListener("click", customerSignIn)
    document.querySelector("h1#login").addEventListener("focus", () => {
      hideErrorMessages()
      if (email.value && !email.checkValidity()) displayErrorMessage(email)
      email.focus()
    })

    signInForm.addEventListener("keydown", (evt) => {
      if (evt.key === "Enter") {
        evt.preventDefault() // Prevents the default form submission
        if (signInButton.disabled) return
        signInButton.click()
      }
    })

    const urlSearchParams = new URLSearchParams(window.location.search)
    if (urlSearchParams) {
      if (urlSearchParams.has("confirmation")) {
        document.querySelector(
          ".customer.login .loading__overlay",
        ).style.display = "block"
        setTimeout(() => {
          const url = new URL(window.location.href)
          const params = url.searchParams
          params.delete("confirmation")
          url.search = params.toString()
          window.location.href = url.toString()
        }, 5000)
      }
      const entries = urlSearchParams.entries()
      if (entries && entries.forEach) {
        entries.forEach(([key, value]) => {
          if (key === "password") {
            return
          }
          const input = document.querySelector(`input[name='customer[${key}]']`)
          if (input) {
            input.value = value
          }
        })
      }
    }
    // init password field
    const passwordWrapper = password.closest(".field")
    const toggleBtnHTML = `<button class="password-visible__toggle" type="button" aria-pressed="false" aria-controls="pWord">
      <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60"><path d="M59.715 28.969C59.238 28.176 47.863 9.594 30 9.594S.762 28.176.285 28.969a2.013 2.013 0 0 0 0 2.062C.762 31.824 12.137 50.406 30 50.406s29.238-18.582 29.715-19.375a2.013 2.013 0 0 0 0-2.062ZM30 0" stroke="#252525" fill="#252525"/><path d="M30 16.496c-7.445 0-13.504 6.059-13.504 13.504 0 7.445 6.059 13.504 13.504 13.504 7.445 0 13.504-6.059 13.504-13.504 0-7.445-6.059-13.504-13.504-13.504Zm0 23c-5.238 0-9.496-4.262-9.496-9.496 0-5.238 4.258-9.496 9.496-9.496s9.496 4.258 9.496 9.496c0 5.234-4.258 9.496-9.496 9.496Zm0 0" stroke="#fff" fill="#fff"/><path d="M30 24.824a5.175 5.175 0 1 0 0 10.348 5.174 5.174 0 1 0 0-10.348Zm0 0" stroke="#252525" fill="#252525"/></svg>
      <span class="visually-hidden">Show password</span>
      </button>`
    passwordWrapper.insertAdjacentHTML("beforeend", toggleBtnHTML)
    const toggleBtn = passwordWrapper.querySelector(".password-visible__toggle")
    passwordWrapper.setAttribute("role", "group")
    passwordWrapper.setAttribute("aria-labelledby", "pWord")
    toggleBtn.addEventListener("click", () => {
      togglePasswordVisibility(passwordWrapper)
    })
    password.addEventListener("keyup", checkValidPasswords)
    password.addEventListener("blur", (evt) => {
      if (!password.checkValidity()) {
        setTimeout(displayErrorMessage, 200, password)
        // slideDown(passwordReqs)
      } else {
        hideErrorMessages(password)
      }
    })

    forgotLink.addEventListener("click", (evt) => {
      dataLayer.push({
        event: "forgot_password",
        page_location: window.location.href,
      })
      document.querySelector("#RecoverEmail").value = email.value
    })

    // init text fields
    const registerTexts = signInForm.querySelectorAll(
      "input[type='text'],input[type='email']",
    )
    for (idx in registerTexts) {
      const txtInput = registerTexts[idx]
      if (typeof txtInput === "object") {
        txtInput.addEventListener("keyup", (evt) => {
          const txtInput = evt.target
          if (txtInput.closest(".field").classList.contains("error")) {
            if (txtInput.checkValidity()) {
              hideErrorMessages(txtInput)
            }
          }
          if (
            txtInput.type === "email" &&
            signInForm
              .querySelector("a .forgot-password")
              .classList.contains("hidden")
          ) {
            signInForm
              .querySelector("a .forgot-password")
              .classList.remove("hidden")
            signInForm
              .querySelector("a .reset-password")
              .classList.add("hidden")
          }
        })
        txtInput.addEventListener("blur", (evt) => {
          txtInput.value = txtInput.value.trim()
          if (!txtInput.checkValidity()) {
            setTimeout(displayErrorMessage, 200, txtInput)
          }
        })
      }
    }
  }

  /* SLIDE UP */
  const slideUp = (target, duration = 500) => {
    target.style.transitionProperty = "height, margin, padding"
    target.style.transitionDuration = duration + "ms"
    target.style.boxSizing = "border-box"
    target.style.height = target.offsetHeight + "px"
    target.offsetHeight
    target.style.overflow = "hidden"
    target.style.height = 0
    target.style.paddingTop = 0
    target.style.paddingBottom = 0
    target.style.marginTop = 0
    target.style.marginBottom = 0
    window.setTimeout(() => {
      target.style.display = "none"
      target.style.removeProperty("height")
      target.style.removeProperty("padding-top")
      target.style.removeProperty("padding-bottom")
      target.style.removeProperty("margin-top")
      target.style.removeProperty("margin-bottom")
      target.style.removeProperty("overflow")
      target.style.removeProperty("transition-duration")
      target.style.removeProperty("transition-property")
      //alert("!");
    }, duration)
  }

  /* SLIDE DOWN */
  const slideDown = (target, duration = 500) => {
    target.style.removeProperty("display")
    let display = window.getComputedStyle(target).display
    if (display === "none") display = "block"
    target.style.display = display
    let height = target.offsetHeight
    target.style.overflow = "hidden"
    target.style.height = 0
    target.style.paddingTop = 0
    target.style.paddingBottom = 0
    target.style.marginTop = 0
    target.style.marginBottom = 0
    target.offsetHeight
    target.style.boxSizing = "border-box"
    target.style.transitionProperty = "height, margin, padding"
    target.style.transitionDuration = duration + "ms"
    target.style.height = height + "px"
    target.style.removeProperty("padding-top")
    target.style.removeProperty("padding-bottom")
    target.style.removeProperty("margin-top")
    target.style.removeProperty("margin-bottom")
    window.setTimeout(() => {
      target.style.removeProperty("height")
      target.style.removeProperty("overflow")
      target.style.removeProperty("transition-duration")
      target.style.removeProperty("transition-property")
    }, duration)
  }

  const errorContainer = signInForm.querySelector(".form-error-container")
  const errorMessage = errorContainer.querySelector(".form-error-message")
  const displayErrorMessage = (input, message) => {
    if (input) {
      const field = input.closest(".field")
      const errorMsg = field.nextElementSibling
      field.classList.add("error")
      errorMsg.classList.remove("hidden")
      input.setAttribute("aria-invalid", "true")
      input.setAttribute(
        "aria-describedby",
        "Error-" + input.getAttribute("id"),
      )
      if (message) {
        errorMsg.innerHTML = message
      } else {
        errorMsg.innerHTML = errorMsg.getAttribute("data-default")
      }
    }
  }

  const hideError = (input) => {
    const field = input.closest(".field")
    const errorMsg = field.nextElementSibling
    field.classList.remove("error")
    errorMsg.innerHTML = ""
    errorMsg.classList.add("hidden")
    input.removeAttribute("aria-invalid")
    input.removeAttribute("aria-describedby")
    if (input.name.indexOf("password") !== -1) {
      slideUp(passwordReqs)
    }
  }
  const hideErrorMessages = (input, delay = 0) => {
    if (input) delay = 200
    let inputs = input ? [input] : signInForm.querySelectorAll(".field > input")
    for (idx in inputs) {
      let input = inputs[idx]
      if (typeof input === "object") {
        if (delay) {
          setTimeout(hideError, delay, input)
        } else {
          hideError(input)
        }
      }
    }
    errorContainer.classList.add("hidden")
    errorMessage.textContent = ""
  }

  const checkValidPasswords = (evt) => {
    const pwInput = evt.target
    if (pwInput.closest(".field").classList.contains("error")) {
      if (pwInput.checkValidity()) {
        hideErrorMessages(pwInput)
      }
    }
    // validate length, uppercase, number
    if (password.value.length >= 8) {
      $("#pwValidLength", signInForm).addClass("good")
    } else {
      $("#pwValidLength", signInForm).removeClass("good")
    }
    if (/[A-Z]/.test(password.value)) {
      $("#pwValidLetter", signInForm).addClass("good")
    } else {
      $("#pwValidLetter", signInForm).removeClass("good")
    }
    if (/[\d]/.test(password.value)) {
      $("#pwValidNumber", signInForm).addClass("good")
    } else {
      $("#pwValidNumber", signInForm).removeClass("good")
    }
  }

  const togglePasswordVisibility = (field, setVisible) => {
    const toggleBtn = field.querySelector(".password-visible__toggle")
    const pwInput = field.querySelector("input")
    const announce = field.querySelector(".announce")
    if (
      (typeof setVisible === "boolean" && setVisible) ||
      toggleBtn.getAttribute("aria-pressed") === "false"
    ) {
      toggleBtn.setAttribute("aria-pressed", "true")
      pwInput.setAttribute("type", "text")
      announce.textContent = "Your password is shown!"
    } else if (
      (typeof setVisible === "boolean" && !setVisible) ||
      toggleBtn.getAttribute("aria-pressed") === "true"
    ) {
      toggleBtn.setAttribute("aria-pressed", "false")
      pwInput.setAttribute("type", "password")
      announce.textContent = "Your password is hidden!"
    }
  }

  const loginFailure = (message) => {
    dataLayer.push({
      event: "login_failure",
      message: message,
      page_location: window.location.href,
    })
  }

  const getSiteRegion = () => {
    let region = window.Shopify?.theme?.name?.match(
      /[-\/](anz|ca|eu|uk|us)\//,
    )?.[1]
    if (!region) {
      region = location.hostname?.match(/-(anz|ca|eu|uk|us)[-.]/)?.[1]
    }
    return region || "us"
  }

  const customerSignIn = async (event) => {
    event.preventDefault()
    hideErrorMessages()
    let errors = false
    if (!email.checkValidity()) {
      displayErrorMessage(email)
      errors = true
    }
    if (!password.checkValidity()) {
      displayErrorMessage(password)
      //slideDown(passwordReqs)
      errors = true
    }
    if (errors) return

    if (password.getAttribute("type") === "text") {
      togglePasswordVisibility(password.closest(".field"), false)
    }

    try {
      const emailTrimmed = email.value.trim()
      const encPassword = btoa(password.value) // TODO implement encryption in transit
      signInButton.disabled = true
      const response = await fetch("/apps/custom-events", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event: "sign-in",
          email: emailTrimmed,
          password: encPassword,
          region: getSiteRegion(),
        }),
      })
      const responseJson = await response.json()

      if (response.status !== 200) {
        signInButton.disabled = false
        let message = responseJson.message
        if (message === "COGNITO_FAILURE") {
          message = responseJson.payload.error
        }
        if (message === "UserNotConfirmedException") {
          $(".customer.login h1, .customer.login form").hide()
          const acntConf = document.querySelector("account-confirmation")
          acntConf.initialize(emailTrimmed, encPassword)
          return loginFailure(message)
        }
        const errorMsg = signInForm.querySelector("#" + message)
        if (errorMsg) {
          if (message.toUpperCase().indexOf("PASSWORD") !== -1) {
            displayErrorMessage(password, errorMsg.innerHTML)
            if (message === "PasswordResetRequiredException") {
              signInForm
                .querySelector("a .forgot-password")
                .classList.add("hidden")
              signInForm
                .querySelector("a .reset-password")
                .classList.remove("hidden")
            }
          } else if (message === "COGNITO_NOT_AUTHORIZED") {
            const field = password.closest(".field")
            const pwErrorMsg = field.nextElementSibling
            pwErrorMsg.classList.remove("hidden")
            pwErrorMsg.innerHTML = errorMsg.innerHTML
          } else {
            displayErrorMessage(email, errorMsg.innerHTML)
          }
          return loginFailure(errorMsg.textContent.trim())
        }
        errorContainer.classList.remove("hidden")
        errorMessage.textContent = message
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        })

        return loginFailure(message)
      }
      //signInForm.reset()

      dataLayer.push({
        event: "login",
        method: "email",
        page_location: window.location.href,
      })

      // Prefer tokens from custom-events; otherwise mint via Cognito directly
      // BEFORE multipass redirect so localStorage survives the navigation.
      const plainPassword = password.value
      if (responseJson.cognito_tokens && window.TBAuth) {
        window.TBAuth.setTokens(responseJson.cognito_tokens)
      }

      const expectedClient = tbAuthExpectedClientId()
      const storedTokens = window.TBAuth ? window.TBAuth.getTokens() : null
      const hasUsableTokens =
        storedTokens &&
        tbAuthTokensMatchSignIn(
          storedTokens.idToken,
          emailTrimmed,
          expectedClient,
        )

      // Drop stale localStorage tokens (wrong user / wrong client) before remint
      // so a failed remint cannot leave the previous account's SA history.
      if (window.TBAuth && storedTokens && !hasUsableTokens) {
        window.TBAuth.clearTokens()
      }

      if (
        window.TBAuth &&
        typeof window.TBAuth.signInWithPassword === "function" &&
        !hasUsableTokens
      ) {
        try {
          // Remint with the Shopping Assistant client only — do not fall back
          // to the classic Shopify Cognito client or Identity Pool rejects the
          // token and chat history stays guest/device-local.
          await window.TBAuth.signInWithPassword(emailTrimmed, plainPassword, {
            clientId: expectedClient || undefined,
            exclusiveClients: Boolean(expectedClient),
          })
        } catch (tbAuthError) {
          console.warn(
            "[TBAuth] Cognito token fallback failed; Shopping Assistant history stays guest-only",
            tbAuthError,
          )
        }
      } else if (!hasUsableTokens && !responseJson.cognito_tokens) {
        console.warn(
          "[TBAuth] sign-in response missing cognito_tokens and TBAuth fallback unavailable",
        )
      }

      // Drop tokens that still don't match this sign-in (wrong aud / user).
      if (window.TBAuth) {
        const afterRemint = window.TBAuth.getTokens()
        if (
          afterRemint &&
          !tbAuthTokensMatchSignIn(
            afterRemint.idToken,
            emailTrimmed,
            expectedClient,
          )
        ) {
          window.TBAuth.clearTokens()
          console.warn(
            "[TBAuth] Cleared Cognito tokens that still mismatched SA client/user after remint",
          )
        }
      }

      if (window.TBAuth && !window.TBAuth.getIdToken()) {
        console.warn(
          "[TBAuth] No id_token in localStorage after login. Key:",
          window.TBAuth.storageKey,
          "config:",
          window.__TB_AUTH_CONFIG__,
        )
      }

      // login success - use multipass token
      const urlParams = new URLSearchParams(window.location.search)
      const urlReturnTo = urlParams.get("return_to")
      const urlCheckoutUrl = urlParams.get("checkout_url")
      const formReturnTo = signInForm.querySelector(
        'input[name="return_to"]',
      )?.value
      const dynamicHeroRedirectUrl = thisModal
        ? ""
        : getDynamicHeroRedirectUrl()
      const announcementBarRedirectData = thisModal
        ? null
        : getAnnouncementBarRedirectData()
      const announcementBarRedirectUrl = getAnnouncementBarRedirectUrl(
        announcementBarRedirectData,
      )
      const elModalLoggedIn = document.querySelector(
        thisModal?.dataset?.loggedinModalSelector,
      )

      if (urlCheckoutUrl) {
        const decodedCheckoutUrl = decodeURIComponent(urlCheckoutUrl)
        await completeMultipassLogin(responseJson.return_to, decodedCheckoutUrl)
        return
      }

      if (dynamicHeroRedirectUrl) {
        await completeMultipassLogin(
          responseJson.return_to,
          dynamicHeroRedirectUrl,
          {
            clearDynamicHeroRedirectUrl: true,
          },
        )
        return
      }

      if (announcementBarRedirectUrl) {
        await completeMultipassLogin(
          responseJson.return_to,
          announcementBarRedirectUrl,
          {
            clearAnnouncementBarRedirectData: true,
          },
        )
        return
      }

      if (urlReturnTo || formReturnTo || elModalLoggedIn) {
        if (elModalLoggedIn) {
          await fetch(responseJson.return_to, {
            method: "GET",
            credentials: "include",
          })
          thisModal.hide()
          elModalLoggedIn.show()
        } else if (urlReturnTo) {
          await completeMultipassLogin(responseJson.return_to, urlReturnTo)
        } else {
          await completeMultipassLogin(responseJson.return_to, formReturnTo)
        }
      } else {
        await completeMultipassLogin(responseJson.return_to, "/account")
      }
    } catch (error) {
      signInButton.disabled = false
      errorContainer.classList.remove("hidden")
      errorMessage.textContent = "Unexpected error"
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
      console.error(error)
    }
  }

  init()
}
loginForm()
